const popups = {
  notSubscribedCountdown: 'notSubscribedCountdown',
}

export default popups
